var map = {
	"./music-instructions.json": 4811,
	"./music-library-intro2024.json": 4812,
	"./music-library-launch2024.json": 4813,
	"./music-progression.json": 4814,
	"./startSourcesAdvanced.json": 4815,
	"./startSourcesSimple.json": 4816,
	"./startSourcesSimple2.json": 4817,
	"./startSourcesTracks.json": 4818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4514;